import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

const InfoMessage = ({ message, containerClass }) => {
  return (
    <div className={containerClass}>
      <Icon className="info-icon" name="info circle" size="large" />
      <span>{message}</span>
    </div>
  );
};

InfoMessage.propTypes = {
  containerClass: PropTypes.string,
  message: PropTypes.string,
};

export default InfoMessage;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/InfoMessage.js